var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar_menu" }, [
    _c("div", { staticClass: "sidebar-navigation" }, [
      _c(
        "a",
        {
          class: [
            "sidebar-navigation-icon",
            { active: this.showSidebarMenu == "metadata" },
          ],
          on: { click: _vm.openSidebarMenu },
        },
        [_c("i", { staticClass: "fa fa-cog" })]
      ),
    ]),
    _vm._v(" "),
    this.showSidebarMenu == "metadata"
      ? _c(
          "div",
          { staticClass: "sidebar-content" },
          [_c("MetadataComponent")],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }